import axios from '../../axios';

export type ServiceResponse = {
  plateNumber: string;
  itemName: string;
  branchName: string;
  piece: string;
};

export default async function getTireStorage(): Promise<ServiceResponse[]> {
  let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/tire/usage`);
  return res.data;
}
